import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import Intersect from 'vuetify/lib/directives/intersect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "memory-board text--text" }, [
    _c(
      "section",
      { staticClass: "b-container" },
      [
        _c("h1", { staticClass: "text-h5 mb-4" }, [
          _vm._v("\n      Доска памяти врачей\n    "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-body-2 mb-6" }, [
          _vm._v(
            "\n      Светлая память тем, кто посвятил свою жизнь помощи другим.\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-4" },
          [
            _c(_setup.CoreSearchField, {
              staticClass: "mb-2",
              attrs: {
                value: _setup.searchQuery,
                maxlength: "150",
                autocomplete: "off",
                placeholder: "ФИО врача",
                "debounce-ms": 500,
              },
              on: {
                "input:debounced": function ($event) {
                  _setup.searchQuery = $event
                },
              },
            }),
            _vm._v(" "),
            _c(_setup.DoctorFilter, {
              model: {
                value: _setup.selectedCity,
                callback: function ($$v) {
                  _setup.selectedCity = $$v
                },
                expression: "selectedCity",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _setup.searchQuery && !_setup.doctors.length
          ? _c(_setup.DoctorListEmpty, {
              staticClass: "py-2",
              attrs: { "search-query": _setup.searchQuery },
            })
          : [
              _c(
                "div",
                { staticClass: "memory-board__cards" },
                _vm._l(_setup.doctors, function (doctor, i) {
                  return _c(_setup.DoctorCard, {
                    key: i,
                    attrs: { doctor: doctor },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _setup.isExistNextPage
                ? _c(
                    "div",
                    { staticClass: "mt-8 w-md-33 mx-auto" },
                    [
                      _setup.error
                        ? _c(
                            VBtn,
                            {
                              attrs: {
                                block: "",
                                depressed: "",
                                variant: "text",
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  _setup.error = false
                                },
                              },
                            },
                            [_vm._v("\n          Загрузить ещё\n        ")]
                          )
                        : _c(VProgressCircular, {
                            directives: [
                              {
                                def: Intersect,
                                name: "intersect",
                                rawName: "v-intersect",
                                value: _setup.onIntersect,
                                expression: "onIntersect",
                              },
                            ],
                            staticClass: "d-flex mx-auto",
                            attrs: {
                              color: "primary",
                              width: 2.5,
                              size: 32,
                              indeterminate: "",
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
        _vm._v(" "),
        _c(VFadeTransition, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _setup.isVisibleBtnScroll,
                  expression: "isVisibleBtnScroll",
                },
              ],
              staticClass: "memory-board__scroll-button",
            },
            [
              _c(_setup.CoreScrollUpButton, {
                staticClass: "b-container d-flex justify-end",
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(_setup.CoreSnackbar),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }